var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgRescaleIcon = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 24,
  height: 24
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  fill: "none"
}, /*#__PURE__*/React.createElement("path", {
  d: "M0 0h24v24H0z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#006C8E",
  fillRule: "evenodd",
  d: "M4 22q-.824 0-1.413-.587A1.93 1.93 0 0 1 2 20V4q0-.824.587-1.413A1.93 1.93 0 0 1 4 2h16q.824 0 1.413.587.586.589.587 1.413v16q0 .824-.587 1.413A1.93 1.93 0 0 1 20 22z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#D3F4FF",
  fillRule: "evenodd",
  d: "M4 20h16V4H4z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#006C8E",
  d: "M13.5 18H18v-4.5h-2V16h-2.5zm-3 0H6v-4.5h2V16h2.5zm3-12H18v4.5h-2V8h-2.5zM6 10.5h2V8h2.5V6H6z"
}))));
export default SvgRescaleIcon;